import React from 'react';
import { UserMinus, Users } from 'lucide-react';
import { doctorInitials, MEMBER_STATUS_DETAILS } from './MemberAvatars';

export function MemberRoster({ members = [], canManageMembers = false, ownerId, onRemove, removingDoctorId }) {
  return (
    <section className="collab-member-roster" aria-labelledby="collab-member-roster-title">
      <header className="collab-member-roster__header">
        <div>
          <p className="collab-eyebrow">Care team</p>
          <h3 id="collab-member-roster-title"><Users size={18} /> Collaborators</h3>
        </div>
        <span>{members.length} {members.length === 1 ? 'doctor' : 'doctors'}</span>
      </header>
      {members.length > 0 ? (
        <ul className="collab-member-roster__list">
          {members.map((member) => {
            const status = member.status || 'active';
            const statusDetail = MEMBER_STATUS_DETAILS[status] || MEMBER_STATUS_DETAILS.active;
            return (
              <li key={member.id || member.doctor?.id}>
                <span className={`collab-member-roster__avatar collab-member-roster__avatar--${status}`} aria-hidden="true">
                  {doctorInitials(member.doctor)}
                </span>
                <span className="collab-member-roster__identity">
                  <strong>{member.doctor?.name || 'Doctor'}</strong>
                  <small className={`collab-member-roster__status collab-member-roster__status--${status}`}>{statusDetail.label}</small>
                </span>
                {canManageMembers && String(member.doctor?.id) !== String(ownerId) && ['member', 'invited'].includes(status) && (
                  <button type="button" className="collab-member-roster__remove" aria-label={`Remove ${member.doctor?.name || 'doctor'}`} disabled={String(removingDoctorId) === String(member.doctor?.id)} onClick={() => onRemove?.(member)}><UserMinus size={15} /> Remove</button>
                )}
              </li>
            );
          })}
        </ul>
      ) : <p className="collab-member-roster__empty">No collaborator details are available.</p>}
    </section>
  );
}

export default MemberRoster;
